// This file is auto-generated by scripts/generate-registries.js. Do not edit directly.
import { ToolEntry } from './types';

export const CORE_TOOLS: ToolEntry[] = [
  {
    "id": "advanced-rotate",
    "name": "Advanced Rotate",
    "desc": "Rotate images to any angle with precise degree control",
    "href": "/image-tools/advanced-rotate/",
    "category": "image",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "image",
      "rotate",
      "angle",
      "degrees",
      "transform",
      "straighten"
    ],
    "input": "image",
    "output": "image",
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "aes-encrypt-decrypt",
    "name": "Aes Encrypt Decrypt",
    "desc": "Encrypt and decrypt text or files using AES, entirely in your browser.",
    "href": "/security-tools/aes-encrypt-decrypt/",
    "category": "security",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "aes encrypt decrypt",
      "security"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "age-calculator",
    "name": "Age Calculator",
    "desc": "Calculate exact age in years, months, and days with offline precision date math. Supports canonical query parameters ?dob=YYYY-MM-DD&as_of=YYYY-MM-DD.",
    "href": "/calculators/age-calculator/",
    "category": "calculators",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "age",
      "birthday",
      "years",
      "exact age",
      "calendar diff",
      "birth date",
      "zodiac",
      "nakshatra"
    ],
    "input": null,
    "output": null,
    "related": [
      "date-calculator",
      "time-calculator",
      "countdown-timer",
      "calendar"
    ],
    "subCategory": "Date & Time",
    "requiresNetwork": false
  },
  {
    "id": "ai-pdf-cleanup",
    "name": "AI Document Intelligence & PDF Cleanup",
    "desc": "Clean up scanned PDFs, auto-deskew pages, denoise, and generate searchable PDFs using local AI",
    "href": "/pdf-tools/ai-pdf-cleanup/",
    "category": "pdf",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": true,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "ai pdf cleanup",
      "deskew",
      "denoise",
      "searchable pdf",
      "document ai",
      "ocr pdf"
    ],
    "input": "pdf",
    "output": "pdf",
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "aspect-ratio-converter",
    "name": "Aspect Ratio Converter",
    "desc": "Convert images to standard aspect ratios like 1:1, 16:9, 4:3",
    "href": "/image-tools/aspect-ratio-converter/",
    "category": "image",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "image",
      "aspect",
      "ratio",
      "resize",
      "crop",
      "pad",
      "16:9",
      "4:3",
      "1:1",
      "instagram",
      "youtube"
    ],
    "input": "image",
    "output": "image",
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "audio-converter",
    "name": "Audio Converter",
    "desc": "Convert audio files between formats like MP3 and WAV locally for compatibility.",
    "href": "/media-tools/audio-converter/",
    "category": "media",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "audio converter",
      "media"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "avif-converter",
    "name": "AVIF Converter",
    "desc": "Convert images to the next-gen AVIF format for maximum compression",
    "href": "/image-tools/avif-converter/",
    "category": "image",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "image",
      "convert",
      "avif",
      "next-gen",
      "compress",
      "optimization"
    ],
    "input": "image",
    "output": "image",
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "banking-tools",
    "name": "Banking Tools",
    "desc": "Advanced financial data parsers for EMV, SWIFT, and core banking logs",
    "href": "/developer-tools/banking-tools/",
    "category": "developer",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "banking tools",
      "iso 8583",
      "emv tlv",
      "swift parser",
      "track 2",
      "developer"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Analyzers & Viewers",
    "requiresNetwork": false
  },
  {
    "id": "barcode-scanner",
    "name": "Barcode & QR Scanner",
    "desc": "Scan barcodes and QR codes using camera",
    "href": "/utilities/barcode-scanner/",
    "category": "utilities",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-06-05",
    "keywords": [
      "barcode",
      "qr scanner",
      "upc",
      "ean",
      "scan"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "base64",
    "name": "Base64 Encode/Decode",
    "desc": "Encode or decode Base64 strings",
    "href": "/developer-tools/base64/",
    "category": "developer",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "base64",
      "encode",
      "decode"
    ],
    "input": null,
    "output": null,
    "related": [
      "url-encoder",
      "hash-generator",
      "jwt-decoder"
    ],
    "subCategory": "Converters",
    "requiresNetwork": false
  },
  {
    "id": "base64url-converter",
    "name": "Base64url Converter",
    "desc": "Encode or decode text to URL-safe Base64 format to safely transmit data.",
    "href": "/security-tools/base64url-converter/",
    "category": "security",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "base64url converter",
      "security"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "batch-image-converter",
    "name": "Batch Image Converter",
    "desc": "Convert multiple images between formats in one batch operation",
    "href": "/image-tools/batch-image-converter/",
    "category": "image",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "image",
      "batch",
      "convert",
      "bulk",
      "format",
      "jpg",
      "png",
      "webp",
      "mass"
    ],
    "input": "image",
    "output": "image",
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "bg-remover",
    "name": "Background Remover",
    "desc": "Remove image backgrounds locally",
    "href": "/image-tools/bg-remover/",
    "category": "image",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": true,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "image",
      "background",
      "remove",
      "transparent"
    ],
    "input": "image",
    "output": "image",
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "bmi-calculator",
    "name": "Bmi Calculator",
    "desc": "Calculate your Body Mass Index (BMI), BMI Prime, Ponderal Index, and healthy weight category",
    "href": "/calculators/bmi-calculator/",
    "category": "calculators",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "bmi",
      "bmi calculator",
      "body mass index",
      "bmi prime",
      "ponderal index",
      "healthy weight",
      "overweight",
      "underweight",
      "fitness",
      "weight loss"
    ],
    "input": null,
    "output": null,
    "related": [
      "percentage-calculator",
      "date-calculator",
      "age-calculator"
    ],
    "subCategory": "Health & Fitness",
    "requiresNetwork": false
  },
  {
    "id": "bmp-converter",
    "name": "BMP Converter",
    "desc": "Convert images to the uncompressed BMP format",
    "href": "/image-tools/bmp-converter/",
    "category": "image",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "bmp",
      "bitmap",
      "windows",
      "convert",
      "uncompressed"
    ],
    "input": "image",
    "output": "image",
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "border-generator",
    "name": "Border Generator",
    "desc": "Add decorative borders to your images with custom styles",
    "href": "/image-tools/border-generator/",
    "category": "image",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "image",
      "border",
      "frame",
      "decoration",
      "solid",
      "dashed",
      "rounded"
    ],
    "input": "image",
    "output": "image",
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "box-shadow-generator",
    "name": "Box Shadow Generator",
    "desc": "Design CSS box shadows visually and copy clean CSS snippets for layouts.",
    "href": "/developer-tools/box-shadow-generator/",
    "category": "developer",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "box shadow generator",
      "developer"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Generators",
    "requiresNetwork": false
  },
  {
    "id": "bulk-resizer",
    "name": "Bulk Image Resize",
    "desc": "Resize many images at once",
    "href": "/image-tools/bulk-resizer/",
    "category": "image",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "image",
      "bulk",
      "batch",
      "resize"
    ],
    "input": "image",
    "output": "image",
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "cagr-calculator",
    "name": "CAGR Calculator",
    "desc": "Compound Annual Growth Rate",
    "href": "/calculators/cagr-calculator/",
    "category": "calculators",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": null,
    "keywords": [
      "cagr",
      "growth",
      "return",
      "annualized"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Financial",
    "requiresNetwork": false
  },
  {
    "id": "calculator",
    "name": "Calculator",
    "desc": "Unified calculator with seamless standard and scientific modes",
    "href": "/calculators/calculator/",
    "category": "calculators",
    "icon": null,
    "color": null,
    "featured": true,
    "popular": true,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "calculator",
      "math",
      "scientific",
      "standard",
      "trigonometry"
    ],
    "input": null,
    "output": null,
    "related": [
      "unit-converter",
      "percentage-calculator"
    ],
    "subCategory": "Math",
    "requiresNetwork": false
  },
  {
    "id": "calendar",
    "name": "Calendar",
    "desc": "Professional, local-first calendar with Tamil mode support.",
    "href": "/productivity/calendar/",
    "category": "productivity",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "calendar",
      "productivity",
      "tamil calendar",
      "events",
      "schedule",
      "local-first"
    ],
    "input": "none",
    "output": "none",
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "canvas-resize",
    "name": "Canvas Resize",
    "desc": "Resize the canvas workspace around your image without scaling",
    "href": "/image-tools/canvas-resize/",
    "category": "image",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "image",
      "canvas",
      "resize",
      "workspace",
      "extend",
      "shrink"
    ],
    "input": "image",
    "output": "image",
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "card-masker",
    "name": "Card Masker",
    "desc": "Mask card numbers automatically to securely display and store sensitive financial info.",
    "href": "/security-tools/card-masker/",
    "category": "security",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "card masker",
      "security"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "chart-generator",
    "name": "Chart & Graph Generator",
    "desc": "Create beautiful charts from your data",
    "href": "/productivity/chart-generator/",
    "category": "productivity",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-06-05",
    "keywords": [
      "chart",
      "graph",
      "bar chart",
      "pie chart",
      "line graph",
      "data visualization"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "cipher-tools",
    "name": "Cipher Tools",
    "desc": "Encrypt and decrypt text using classical ciphers like Caesar or Vigenère.",
    "href": "/security-tools/cipher-tools/",
    "category": "security",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "cipher tools",
      "security"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "code-minifier",
    "name": "Code Minifier",
    "desc": "Minify CSS, JS, and HTML",
    "href": "/developer-tools/code-minifier/",
    "category": "developer",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "minify",
      "css",
      "js",
      "html"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Formatters & Minifiers",
    "requiresNetwork": false
  },
  {
    "id": "color-converter",
    "name": "Color Converter",
    "desc": "Convert color formats (HEX, RGB, HSL) to style web applications.",
    "href": "/developer-tools/color-converter/",
    "category": "developer",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "color converter",
      "developer"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Converters",
    "requiresNetwork": false
  },
  {
    "id": "color-match",
    "name": "Color Match",
    "desc": "Pick the exact color swatch under time pressure to test your visual accuracy.",
    "href": "/break-time-tools/color-match/",
    "category": "break-time",
    "icon": null,
    "color": "#8B5CF6",
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-07-10",
    "keywords": [
      "color match",
      "color test",
      "swatch",
      "visual accuracy",
      "reflex",
      "game"
    ],
    "input": null,
    "output": null,
    "related": [
      "reaction-time",
      "memory-match"
    ],
    "subCategory": "Skill Tests",
    "requiresNetwork": false
  },
  {
    "id": "color-palette-extractor",
    "name": "Color Palette Extractor",
    "desc": "Extract dominant color palettes from any image to design themes.",
    "href": "/image-tools/color-palette-extractor/",
    "category": "image",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "color palette extractor",
      "image"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "command-cheat-sheet",
    "name": "Command Cheat Sheet",
    "desc": "Look up development and system commands instantly to speed up your workflow.",
    "href": "/developer-tools/command-cheat-sheet/",
    "category": "developer",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "command cheat sheet",
      "developer"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Generators",
    "requiresNetwork": false
  },
  {
    "id": "compound-interest",
    "name": "Compound Interest Calculator",
    "desc": "Calculate exponential compound interest, recurring monthly contributions, APY yields, and inflation-adjusted future value",
    "href": "/calculators/compound-interest/",
    "category": "calculators",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "compound interest",
      "compound interest calculator",
      "cagr calculator",
      "apy calculator",
      "interest calculator",
      "investment growth",
      "savings calculator",
      "future value",
      "sip calculator"
    ],
    "input": null,
    "output": null,
    "related": [
      "financial-freedom-calculator",
      "percentage-calculator",
      "discount-calculator"
    ],
    "subCategory": "Finance & Investment",
    "requiresNetwork": false
  },
  {
    "id": "compress-pdf",
    "name": "Compress PDF",
    "desc": "Reduce PDF file size",
    "href": "/pdf-tools/compress-pdf/",
    "category": "pdf",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": true,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "pdf",
      "compress",
      "reduce",
      "size"
    ],
    "input": "pdf",
    "output": "pdf",
    "related": [
      "merge-pdf",
      "split-pdf",
      "lock-unlock-pdf",
      "watermark-pdf"
    ],
    "subCategory": "Optimize & Format",
    "requiresNetwork": false
  },
  {
    "id": "compress",
    "name": "Compress",
    "desc": "Bundle files and folders into optimized ZIP archives to save storage space.",
    "href": "/image-tools/compress/",
    "category": "image",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "compress",
      "image"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "contrast-checker",
    "name": "Contrast Checker",
    "desc": "Verify background and foreground contrast to meet WCAG accessibility standards.",
    "href": "/developer-tools/contrast-checker/",
    "category": "developer",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "contrast checker",
      "developer"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Validators & Checkers",
    "requiresNetwork": false
  },
  {
    "id": "core-banking-parser",
    "name": "Core Banking Parser",
    "desc": "Parse core banking trace logs into JSON",
    "href": "/developer-tools/core-banking-parser/",
    "category": "developer",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "finacle tools",
      "banking"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Banking Tools",
    "requiresNetwork": false
  },
  {
    "id": "countdown-timer",
    "name": "Countdown Timer",
    "desc": "Set timers for upcoming milestones or deadlines to keep track of tasks.",
    "href": "/productivity/countdown-timer/",
    "category": "productivity",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "countdown timer",
      "productivity"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "crontab-editor",
    "name": "Crontab Editor",
    "desc": "Build crontab expressions visually and translate them to plain English.",
    "href": "/developer-tools/crontab-editor/",
    "category": "developer",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "crontab editor",
      "developer"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Generators",
    "requiresNetwork": false
  },
  {
    "id": "crop-pdf",
    "name": "Crop PDF",
    "desc": "Crop PDF pages to a specific area",
    "href": "/pdf-tools/crop-pdf/",
    "category": "pdf",
    "icon": "Crop",
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": null,
    "keywords": [
      "pdf",
      "crop",
      "edit",
      "layout"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Optimize & Format",
    "requiresNetwork": false
  },
  {
    "id": "csp-builder",
    "name": "Csp Builder",
    "desc": "Construct secure Content Security Policy headers to protect sites from XSS.",
    "href": "/security-tools/csp-builder/",
    "category": "security",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "csp builder",
      "security"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "csr-generator",
    "name": "Csr Generator",
    "desc": "Generate CSR requests and private keys locally to secure web servers.",
    "href": "/security-tools/csr-generator/",
    "category": "security",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "csr generator",
      "security"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "csv-to-json",
    "name": "Csv To Json",
    "desc": "Convert tabular CSV file content into structured JSON objects.",
    "href": "/developer-tools/csv-to-json/",
    "category": "developer",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "csv to json",
      "developer"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Converters",
    "requiresNetwork": false
  },
  {
    "id": "currency-converter",
    "name": "Currency Converter",
    "desc": "Convert between world currencies",
    "href": "/calculators/currency-converter/",
    "category": "calculators",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "currency",
      "exchange",
      "forex",
      "usd",
      "eur",
      "inr"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Math & Units",
    "requiresNetwork": true
  },
  {
    "id": "data-calculator",
    "name": "Data Calculator",
    "desc": "Units, transfer time, cost, & hashes",
    "href": "/calculators/data-calculator/",
    "category": "calculators",
    "icon": null,
    "color": null,
    "featured": true,
    "popular": false,
    "status": "new",
    "lastAdded": null,
    "keywords": [
      "data",
      "units",
      "converter",
      "bandwidth",
      "checksum",
      "md5",
      "sha256"
    ],
    "input": null,
    "output": null,
    "related": [
      "unit-converter",
      "json-formatter",
      "qrcode"
    ],
    "subCategory": "Math & Units",
    "requiresNetwork": false
  },
  {
    "id": "date-calculator",
    "name": "Date Calculator",
    "desc": "Calculate date differences or add/subtract time from any date with offline precision math",
    "href": "/calculators/date-calculator/",
    "category": "calculators",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "date",
      "days",
      "difference",
      "add days",
      "subtract days",
      "business days",
      "calendar diff",
      "date offset"
    ],
    "input": null,
    "output": null,
    "related": [
      "age-calculator",
      "time-calculator",
      "countdown-timer",
      "calendar"
    ],
    "subCategory": "Date & Time",
    "requiresNetwork": false
  },
  {
    "id": "delete-blank-pages",
    "name": "Delete Blank Pages",
    "desc": "Automatically detect and remove blank pages from your PDF document.",
    "href": "/pdf-tools/delete-blank-pages/",
    "category": "pdf",
    "icon": "📄",
    "color": "#B91C1C",
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": null,
    "keywords": [
      "delete blank pages",
      "remove empty pages",
      "clean pdf"
    ],
    "input": "pdf",
    "output": "pdf",
    "related": [],
    "subCategory": "Organize & Edit",
    "requiresNetwork": false
  },
  {
    "id": "diff-checker",
    "name": "Diff Checker",
    "desc": "Compare two text snippets",
    "href": "/developer-tools/diff-checker/",
    "category": "developer",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "diff",
      "compare",
      "text"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Validators & Checkers",
    "requiresNetwork": false
  },
  {
    "id": "directory-manifest",
    "name": "Directory Manifest",
    "desc": "Generate recursive folder maps of local directories to document structure.",
    "href": "/security-tools/directory-manifest/",
    "category": "security",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "directory manifest",
      "security"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "discount-calculator",
    "name": "Discount Calculator",
    "desc": "Calculate sale price, double-stacked promo discounts, sales tax, and reverse original price",
    "href": "/calculators/discount-calculator/",
    "category": "calculators",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "discount",
      "discount calculator",
      "sale price",
      "percent off",
      "savings",
      "double discount",
      "tax calculator",
      "reverse discount"
    ],
    "input": null,
    "output": null,
    "related": [
      "percentage-calculator",
      "gst-calculator",
      "compound-interest"
    ],
    "subCategory": "Financial",
    "requiresNetwork": false
  },
  {
    "id": "duplicate-pages",
    "name": "Duplicate PDF Pages",
    "desc": "Duplicate and copy specific pages in a PDF document offline.",
    "href": "/pdf-tools/duplicate-pages/",
    "category": "pdf",
    "icon": "📑",
    "color": "#B91C1C",
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": null,
    "keywords": [
      "duplicate pdf pages",
      "copy pages",
      "clone pages"
    ],
    "input": "pdf",
    "output": "pdf",
    "related": [],
    "subCategory": "Organize & Edit",
    "requiresNetwork": false
  },
  {
    "id": "ecdh-key-exchange",
    "name": "Ecdh Key Exchange",
    "desc": "Generate shared cryptographic keys using ECDH protocols.",
    "href": "/security-tools/ecdh-key-exchange/",
    "category": "security",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "ecdh key exchange",
      "security"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "ecdsa-sign",
    "name": "Ecdsa Sign",
    "desc": "Sign and verify payload strings using secure ECDSA certificates.",
    "href": "/security-tools/ecdsa-sign/",
    "category": "security",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "ecdsa sign",
      "security"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "edit-metadata",
    "name": "Edit PDF Metadata",
    "desc": "View and edit PDF properties like Title, Author, and Subject",
    "href": "/pdf-tools/edit-metadata/",
    "category": "pdf",
    "icon": "FileEdit",
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": null,
    "keywords": [
      "pdf",
      "metadata",
      "properties",
      "author",
      "title"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Security & Metadata",
    "requiresNetwork": false
  },
  {
    "id": "emi-calculator",
    "name": "EMI Calculator",
    "desc": "Calculate home loan & car loan EMI, reducing balance interest, amortization schedule, and prepayment savings",
    "href": "/calculators/emi-calculator/",
    "category": "calculators",
    "icon": null,
    "color": "#4F46E5",
    "featured": true,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "emi",
      "emi calculator",
      "loan",
      "loan calculator",
      "home loan emi",
      "car loan emi",
      "interest",
      "mortgage",
      "amortization",
      "prepayment"
    ],
    "input": null,
    "output": null,
    "related": [
      "compound-interest",
      "financial-freedom-calculator",
      "percentage-calculator",
      "discount-calculator"
    ],
    "subCategory": "Financial",
    "requiresNetwork": false
  },
  {
    "id": "emv-tlv-tree",
    "name": "Emv Tlv Tree",
    "desc": "Inspect and parse EMV TLV payment packets for bank transaction analysis.",
    "href": "/developer-tools/emv-tlv-tree/",
    "category": "developer",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "emv tlv tree",
      "banking"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Banking Tools",
    "requiresNetwork": false
  },
  {
    "id": "even-pages-extractor",
    "name": "Even Pages Extractor",
    "desc": "Extract only the even-numbered pages from a PDF document.",
    "href": "/pdf-tools/even-pages-extractor/",
    "category": "pdf",
    "icon": "🔢",
    "color": "#B91C1C",
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": null,
    "keywords": [
      "extract even pages",
      "even pages only",
      "pdf even pages"
    ],
    "input": "pdf",
    "output": "pdf",
    "related": [],
    "subCategory": "Organize & Edit",
    "requiresNetwork": false
  },
  {
    "id": "extract-images",
    "name": "Extract Images",
    "desc": "Pull images out of a PDF",
    "href": "/pdf-tools/extract-images/",
    "category": "pdf",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "pdf",
      "extract",
      "image"
    ],
    "input": "pdf",
    "output": "image",
    "related": [],
    "subCategory": "Convert & Export",
    "requiresNetwork": false
  },
  {
    "id": "extract-pages",
    "name": "Extract PDF Pages",
    "desc": "Extract specific pages or page ranges from a PDF into a new document.",
    "href": "/pdf-tools/extract-pages/",
    "category": "pdf",
    "icon": "📥",
    "color": "#B91C1C",
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": null,
    "keywords": [
      "extract pdf pages",
      "split pdf pages",
      "save pages"
    ],
    "input": "pdf",
    "output": "pdf",
    "related": [],
    "subCategory": "Organize & Edit",
    "requiresNetwork": false
  },
  {
    "id": "face-blur",
    "name": "AI Face Blur & Privacy Shield",
    "desc": "Automatically blur faces and PII objects in photos using local AI",
    "href": "/image-tools/face-blur/",
    "category": "image",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": true,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "face blur",
      "privacy",
      "anonymize",
      "yolo",
      "pii shield",
      "blur photo"
    ],
    "input": "image",
    "output": "image",
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "fake-data-generator",
    "name": "Fake Data Generator",
    "desc": "Generate realistic fake data for testing",
    "href": "/developer-tools/fake-data-generator/",
    "category": "developer",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": true,
    "status": "new",
    "lastAdded": null,
    "keywords": [
      "fake data",
      "mock data",
      "generator",
      "csv",
      "json",
      "sql"
    ],
    "input": null,
    "output": [
      "json",
      "csv",
      "sql"
    ],
    "related": [],
    "subCategory": "Generators",
    "requiresNetwork": false
  },
  {
    "id": "fd-calculator",
    "name": "Fixed Deposit (FD) Calculator",
    "desc": "Calculate FD maturity value, interest payouts, senior citizen rates, APY, TDS deductions, and amortization schedule",
    "href": "/calculators/fd-calculator/",
    "category": "calculators",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "fd calculator",
      "fixed deposit calculator",
      "fd interest calculator",
      "fd maturity calculator",
      "senior citizen fd",
      "cumulative fd",
      "non-cumulative fd",
      "fd interest rate",
      "tds on fd",
      "effective annual yield",
      "apy calculator"
    ],
    "input": null,
    "output": null,
    "related": [
      "compound-interest",
      "rd-calculator",
      "ppf-calculator",
      "interest-calculator",
      "sip-calculator",
      "emi-calculator"
    ],
    "subCategory": "Finance & Investment",
    "requiresNetwork": false
  },
  {
    "id": "file-viewer-diff",
    "name": "File Viewer & Diff",
    "desc": "Local text editor and diff checker",
    "href": "/file-tools/file-viewer-diff/",
    "category": "developer",
    "icon": null,
    "color": null,
    "featured": true,
    "popular": false,
    "status": "new",
    "lastAdded": null,
    "keywords": [
      "file viewer",
      "diff",
      "compare",
      "editor",
      "source code"
    ],
    "input": [
      "any-file",
      "text"
    ],
    "output": [
      "any-file",
      "text"
    ],
    "related": [],
    "subCategory": "Other",
    "requiresNetwork": false
  },
  {
    "id": "financial-freedom-calculator",
    "name": "Financial Freedom Calculator",
    "desc": "Calculate your FIRE number, required SIP, and projected wealth accumulation",
    "href": "/calculators/financial-freedom-calculator/",
    "category": "calculators",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "financial freedom",
      "fire calculator",
      "retirement corpus",
      "sip calculator",
      "wealth accumulation"
    ],
    "input": null,
    "output": null,
    "related": [
      "compound-interest",
      "percentage-calculator",
      "age-calculator"
    ],
    "subCategory": "Finance & Investment",
    "requiresNetwork": false
  },
  {
    "id": "format",
    "name": "Code Formatter",
    "desc": "Auto-format code in many languages",
    "href": "/developer-tools/format/",
    "category": "developer",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "format",
      "prettier",
      "code"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Formatters & Minifiers",
    "requiresNetwork": false
  },
  {
    "id": "game-2048",
    "name": "2048",
    "desc": "Slide and merge tiles to reach 2048. Addictive puzzle game — fully offline.",
    "href": "/break-time-tools/game-2048/",
    "category": "break-time",
    "icon": null,
    "color": "#8B5CF6",
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-07-09",
    "keywords": [
      "2048",
      "puzzle",
      "game",
      "sliding tiles",
      "merge",
      "brain training",
      "fun"
    ],
    "input": null,
    "output": null,
    "related": [
      "tic-tac-toe",
      "memory-match"
    ],
    "subCategory": "Games",
    "requiresNetwork": false
  },
  {
    "id": "gif-creator",
    "name": "Gif Creator",
    "desc": "Convert videos or image frames into optimized, loopable animated GIF files.",
    "href": "/media-tools/gif-creator/",
    "category": "media",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "gif creator",
      "media"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "gif-extractor",
    "name": "GIF Frame Extractor",
    "desc": "Extract individual frames from animated GIFs",
    "href": "/image-tools/gif-extractor/",
    "category": "image",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "gif",
      "extract",
      "frames",
      "animation",
      "split"
    ],
    "input": "image",
    "output": "image",
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "glassmorphism-generator",
    "name": "Glassmorphism Generator",
    "desc": "Generate CSS code for modern frosted-glass card designs.",
    "href": "/developer-tools/glassmorphism-generator/",
    "category": "developer",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "glassmorphism generator",
      "developer"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Generators",
    "requiresNetwork": false
  },
  {
    "id": "gradient-generator",
    "name": "Gradient Generator",
    "desc": "Design linear and radial CSS gradients visually for backgrounds.",
    "href": "/developer-tools/gradient-generator/",
    "category": "developer",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "gradient generator",
      "developer"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Generators",
    "requiresNetwork": false
  },
  {
    "id": "grammar-checker",
    "name": "Grammar & Spell Checker",
    "desc": "100% private, client-side grammar, spell, and readability checker for your text.",
    "href": "/utilities/grammar-checker/",
    "category": "utilities",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-07-19",
    "keywords": [
      "grammar checker",
      "spell checker",
      "text editor",
      "readability",
      "privacy-first",
      "offline"
    ],
    "input": "text",
    "output": "text",
    "related": [
      "markdown"
    ],
    "subCategory": "Text",
    "requiresNetwork": false
  },
  {
    "id": "gratuity-calculator",
    "name": "Gratuity Calculator",
    "desc": "Estimate standard gratuity benefits based on salary and tenure.",
    "href": "/calculators/gratuity-calculator/",
    "category": "calculators",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "gratuity calculator",
      "calculators"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "gst-calculator",
    "name": "GST Calculator",
    "desc": "Calculate GST (Add/Remove) for Indian tax slabs (3%, 5%, 12%, 18%, 28%) with CGST, SGST, and IGST breakdown.",
    "href": "/calculators/gst-calculator/",
    "category": "calculators",
    "icon": null,
    "color": null,
    "featured": true,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "gst",
      "gst calculator",
      "calculate gst india",
      "gst tax calculator",
      "add gst remove gst",
      "reverse gst calculator",
      "cgst sgst igst calculator",
      "online gst calculator",
      "gst amount calculator",
      "inclusive gst",
      "exclusive gst"
    ],
    "input": null,
    "output": null,
    "related": [
      "percentage-calculator",
      "discount-calculator",
      "income-tax",
      "tds-calculator"
    ],
    "subCategory": "Financial",
    "requiresNetwork": false
  },
  {
    "id": "hash-generator",
    "name": "Hash Generator",
    "desc": "MD5, SHA-1/256/512 hashes",
    "href": "/security-tools/hash-generator/",
    "category": "security",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "hash",
      "md5",
      "sha",
      "checksum"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "hash-map-visualizer",
    "name": "Hash Map Visualizer",
    "desc": "Visualize collision resolution strategies in hash map indexes.",
    "href": "/developer-tools/hash-map-visualizer/",
    "category": "developer",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "hash map visualizer",
      "developer"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Analyzers & Viewers",
    "requiresNetwork": false
  },
  {
    "id": "heic-converter",
    "name": "HEIC to JPG",
    "desc": "Convert Apple HEIC photos to standard JPEG locally in your browser",
    "href": "/image-tools/heic-converter/",
    "category": "image",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "heic",
      "heif",
      "jpg",
      "jpeg",
      "convert",
      "apple",
      "iphone",
      "photo",
      "image",
      "browser",
      "converter"
    ],
    "input": "image",
    "output": "image",
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "hkdf-generator",
    "name": "Hkdf Generator",
    "desc": "Derive cryptographically strong keys from raw input using HKDF.",
    "href": "/security-tools/hkdf-generator/",
    "category": "security",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "hkdf generator",
      "security"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "hmac-generator",
    "name": "Hmac Generator",
    "desc": "Calculate keyed-hash message authentication codes (HMAC) to verify integrity.",
    "href": "/security-tools/hmac-generator/",
    "category": "security",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "hmac generator",
      "security"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "hra-calculator",
    "name": "Hra Calculator",
    "desc": "Calculate your House Rent Allowance tax exemptions.",
    "href": "/calculators/hra-calculator/",
    "category": "calculators",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "hra calculator",
      "calculators"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "html-entities",
    "name": "HTML Entities",
    "desc": "Convert characters to HTML entities",
    "href": "/security-tools/html-entities/",
    "category": "security",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "html",
      "entities",
      "escape"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "html-viewer",
    "name": "HTML Online Viewer",
    "desc": "Professional live HTML/CSS/JS editor and sandboxed preview",
    "href": "/developer-tools/html-viewer/",
    "category": "developer",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": null,
    "keywords": [
      "html",
      "viewer",
      "editor",
      "codepen",
      "playground",
      "javascript",
      "css"
    ],
    "input": null,
    "output": null,
    "related": [
      "code-minifier",
      "format",
      "json-formatter"
    ],
    "subCategory": "Analyzers & Viewers",
    "requiresNetwork": false
  },
  {
    "id": "iban-validator",
    "name": "Iban Validator",
    "desc": "Check the validity and checksums of IBAN bank account numbers.",
    "href": "/security-tools/iban-validator/",
    "category": "security",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "iban validator",
      "security"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "ico-generator",
    "name": "ICO Generator",
    "desc": "Create Windows .ico icon files from standard images",
    "href": "/image-tools/ico-generator/",
    "category": "image",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "ico",
      "icon",
      "favicon",
      "windows",
      "convert",
      "generator"
    ],
    "input": "image",
    "output": "image",
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "image-base64",
    "name": "Image to Base64",
    "desc": "Encode images as Base64 data URIs",
    "href": "/image-tools/image-base64/",
    "category": "image",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "image",
      "base64",
      "data uri"
    ],
    "input": "image",
    "output": "text",
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "image-compress",
    "name": "Image Compressor",
    "desc": "Reduce image file size",
    "href": "/image-tools/image-compressor/",
    "category": "image",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "image",
      "compress",
      "jpg",
      "png",
      "webp"
    ],
    "input": "image",
    "output": "image",
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "image-converter",
    "name": "Image Converter",
    "desc": "Convert between JPG, PNG, WebP, AVIF, and BMP",
    "href": "/image-tools/image-converter/",
    "category": "image",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "image",
      "convert",
      "jpg",
      "png",
      "webp",
      "avif",
      "bmp"
    ],
    "input": "image",
    "output": "image",
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "image-crop",
    "name": "Image Crop",
    "desc": "Crop images to ratio or freeform",
    "href": "/image-tools/image-crop/",
    "category": "image",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "image",
      "crop",
      "trim"
    ],
    "input": "image",
    "output": "image",
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "image-flip",
    "name": "Image Flip",
    "desc": "Flip images horizontally, vertically, or both directions instantly",
    "href": "/image-tools/image-flip/",
    "category": "image",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "image",
      "flip",
      "horizontal",
      "vertical",
      "mirror",
      "transform"
    ],
    "input": "image",
    "output": "image",
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "image-mirror",
    "name": "Image Mirror",
    "desc": "Mirror images with a horizontal reflection",
    "href": "/image-tools/image-mirror/",
    "category": "image",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "image",
      "mirror",
      "reflection",
      "horizontal",
      "flip",
      "symmetry"
    ],
    "input": "image",
    "output": "image",
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "image-padding",
    "name": "Image Padding",
    "desc": "Add uniform or per-side padding around your images",
    "href": "/image-tools/image-padding/",
    "category": "image",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "image",
      "padding",
      "margin",
      "space",
      "border",
      "whitespace"
    ],
    "input": "image",
    "output": "image",
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "image-resizer",
    "name": "Image Resizer",
    "desc": "Resize images to exact dimensions",
    "href": "/image-tools/image-resizer/",
    "category": "image",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "image",
      "resize",
      "dimensions"
    ],
    "input": "image",
    "output": "image",
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "image-seo",
    "name": "Image Seo",
    "desc": "Optimize image file names and alt attributes to rank higher on search engines.",
    "href": "/developer-tools/image-seo/",
    "category": "developer",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "image seo",
      "seo"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "SEO Tools",
    "requiresNetwork": false
  },
  {
    "id": "image-to-pdf",
    "name": "Image to PDF",
    "desc": "Convert images into a single PDF",
    "href": "/pdf-tools/image-to-pdf/",
    "category": "pdf",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "image",
      "jpg",
      "png",
      "pdf",
      "convert"
    ],
    "input": "image",
    "output": "pdf",
    "related": [],
    "subCategory": "Convert & Export",
    "requiresNetwork": false
  },
  {
    "id": "image-watermark",
    "name": "Image Watermark",
    "desc": "Add text or image watermarks to your pictures.",
    "href": "/image-tools/image-watermark/",
    "category": "image",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "image",
      "watermark",
      "protect",
      "stamp",
      "logo"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "income-tax",
    "name": "Income Tax",
    "desc": "Calculate annual income tax estimates and select the best tax regime.",
    "href": "/calculators/income-tax/",
    "category": "calculators",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "income tax",
      "calculators"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "inflation-calculator",
    "name": "Inflation Calculator",
    "desc": "Calculate compound price escalation, future purchasing power erosion, loss percentage, and Rule of 70 halving time",
    "href": "/calculators/inflation-calculator/",
    "category": "calculators",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "inflation calculator",
      "purchasing power calculator",
      "cpi inflation",
      "future value of money",
      "cost of living calculator",
      "loss of purchasing power",
      "rule of 70",
      "real vs nominal value",
      "education inflation",
      "medical inflation"
    ],
    "input": null,
    "output": null,
    "related": [
      "compound-interest",
      "sip-calculator",
      "cagr-calculator",
      "percentage-calculator",
      "financial-freedom-calculator"
    ],
    "subCategory": "Finance & Investment",
    "requiresNetwork": false
  },
  {
    "id": "interest-calculator",
    "name": "Interest Calculator",
    "desc": "Calculate simple and compound interest.",
    "href": "/calculators/interest-calculator/",
    "category": "calculators",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "interest",
      "calculator",
      "finance",
      "compound",
      "simple"
    ],
    "input": null,
    "output": null,
    "related": [
      "compound-interest"
    ],
    "subCategory": "Financial",
    "requiresNetwork": false
  },
  {
    "id": "internet-speed-test",
    "name": "Speed Tester",
    "desc": "Measure your internet connection speed",
    "href": "/utilities/internet-speed-test/",
    "category": "utilities",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": null,
    "keywords": [
      "speed",
      "test",
      "internet",
      "wifi",
      "ping",
      "latency"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": true
  },
  {
    "id": "invoice-generator",
    "name": "Invoice Generator",
    "desc": "Build professional custom invoices and download them as PDFs.",
    "href": "/calculators/invoice-generator/",
    "category": "calculators",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "invoice generator",
      "calculators"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "iso8583-bitmap-decoder",
    "name": "Iso8583 Bitmap Decoder",
    "desc": "Parse and visualize ISO 8583 payment card transaction bitmaps.",
    "href": "/security-tools/iso8583-bitmap-decoder/",
    "category": "security",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "iso8583 bitmap decoder",
      "security"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "iso8583-message-parser",
    "name": "Iso8583 Message Parser",
    "desc": "Decode raw financial transaction strings into human-readable messages.",
    "href": "/security-tools/iso8583-message-parser/",
    "category": "security",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "iso8583 message parser",
      "security"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "json-csv",
    "name": "JSON ↔ CSV",
    "desc": "Convert between JSON and CSV",
    "href": "/developer-tools/json-csv/",
    "category": "developer",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": true,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "json",
      "csv",
      "convert"
    ],
    "input": [
      "json",
      "csv"
    ],
    "output": [
      "json",
      "csv"
    ],
    "related": [
      "json-formatter",
      "unit-converter"
    ],
    "subCategory": "Converters",
    "requiresNetwork": false
  },
  {
    "id": "json-formatter",
    "name": "JSON Formatter",
    "desc": "Format and validate JSON",
    "href": "/developer-tools/json-formatter/",
    "category": "developer",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": true,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "json",
      "format",
      "pretty",
      "validate"
    ],
    "input": "json",
    "output": "json",
    "related": [
      "json-csv",
      "base64",
      "format"
    ],
    "subCategory": "Formatters & Minifiers",
    "requiresNetwork": false
  },
  {
    "id": "json-to-ts",
    "name": "JSON to TypeScript",
    "desc": "Generate TypeScript interfaces from JSON",
    "href": "/developer-tools/json-to-ts/",
    "category": "developer",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "json",
      "typescript",
      "ts",
      "interface",
      "types",
      "generator",
      "converter"
    ],
    "input": "json",
    "output": "code",
    "related": [
      "json-formatter",
      "base64"
    ],
    "subCategory": "Converters",
    "requiresNetwork": false
  },
  {
    "id": "json-to-xml",
    "name": "Json To Xml",
    "desc": "Convert JSON to XML and XML to JSON.",
    "href": "/developer-tools/json-to-xml/",
    "category": "developer",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "json to xml",
      "xml to json",
      "xml",
      "json",
      "converter",
      "developer"
    ],
    "input": null,
    "output": null,
    "related": [
      "csv-to-json"
    ],
    "subCategory": "Converters",
    "requiresNetwork": false
  },
  {
    "id": "jwt-decoder",
    "name": "JWT Decoder",
    "desc": "Inspect JSON Web Tokens",
    "href": "/security-tools/jwt-decoder/",
    "category": "security",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "jwt",
      "token",
      "json",
      "decode"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "llms-txt-generator",
    "name": "LLMs.txt Generator",
    "desc": "Generate llms.txt files for AI agents and LLMs to index your site.",
    "href": "/developer-tools/llms-txt-generator/",
    "category": "developer",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "llms.txt",
      "generator",
      "ai",
      "llm",
      "seo",
      "agent"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Generators",
    "requiresNetwork": false
  },
  {
    "id": "lock-unlock-pdf",
    "name": "Lock / Unlock PDF",
    "desc": "Add or remove PDF passwords",
    "href": "/pdf-tools/lock-unlock/",
    "category": "pdf",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "pdf",
      "password",
      "lock",
      "unlock",
      "encrypt"
    ],
    "input": "pdf",
    "output": "pdf",
    "related": [],
    "subCategory": "Security & Metadata",
    "requiresNetwork": false
  },
  {
    "id": "log-analyzer",
    "name": "Log Analyzer",
    "desc": "Analyze and filter server and application access log files.",
    "href": "/developer-tools/log-analyzer/",
    "category": "developer",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "log analyzer",
      "developer"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Analyzers & Viewers",
    "requiresNetwork": false
  },
  {
    "id": "lorem-ipsum",
    "name": "Lorem Ipsum",
    "desc": "Generate custom dummy placeholder text for layouts and copy.",
    "href": "/developer-tools/lorem-ipsum/",
    "category": "developer",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "lorem ipsum",
      "developer"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Generators",
    "requiresNetwork": false
  },
  {
    "id": "luhn-validator",
    "name": "Luhn Validator",
    "desc": "Check identification card numbers using the Luhn checksum algorithm.",
    "href": "/developer-tools/luhn-validator/",
    "category": "developer",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "luhn validator",
      "developer"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Validators & Checkers",
    "requiresNetwork": false
  },
  {
    "id": "lumpsum-calculator",
    "name": "Lumpsum Calculator",
    "desc": "Future value of one-time investment",
    "href": "/calculators/lumpsum-calculator/",
    "category": "calculators",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": null,
    "keywords": [
      "lumpsum",
      "investment",
      "future value",
      "wealth"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Financial",
    "requiresNetwork": false
  },
  {
    "id": "margin-adjustment",
    "name": "Margin Adjustment",
    "desc": "Adjust margins of PDF pages",
    "href": "/pdf-tools/margin-adjustment/",
    "category": "pdf",
    "icon": "Maximize",
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": null,
    "keywords": [
      "pdf",
      "margin",
      "padding",
      "layout"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Optimize & Format",
    "requiresNetwork": false
  },
  {
    "id": "markdown",
    "name": "Markdown Editor",
    "desc": "Professional Markdown editor with live GitHub-style preview, Mermaid diagrams, and high-performance export options.",
    "href": "/utilities/markdown/",
    "category": "utilities",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "markdown",
      "md",
      "editor",
      "preview",
      "mermaid",
      "diagrams",
      "export pdf",
      "export docx"
    ],
    "input": null,
    "output": null,
    "related": [
      "html-viewer",
      "code-minifier",
      "text-utility",
      "word-counter"
    ],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "memory-match",
    "name": "Memory Match",
    "desc": "Flip cards and match pairs. A classic memory-training game with best-score tracking.",
    "href": "/break-time-tools/memory-match/",
    "category": "break-time",
    "icon": null,
    "color": "#8B5CF6",
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-07-09",
    "keywords": [
      "memory match",
      "card flip",
      "pairs",
      "concentration",
      "brain training",
      "game",
      "fun"
    ],
    "input": null,
    "output": null,
    "related": [
      "tic-tac-toe",
      "game-2048"
    ],
    "subCategory": "Brain Training",
    "requiresNetwork": false
  },
  {
    "id": "merge-pdf",
    "name": "Merge PDF",
    "desc": "Combine multiple PDFs into one",
    "href": "/pdf-tools/merge-pdf/",
    "category": "pdf",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": true,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "pdf",
      "merge",
      "combine",
      "join"
    ],
    "input": "pdf",
    "output": "pdf",
    "related": [
      "split-pdf",
      "compress-pdf",
      "page-numbering"
    ],
    "subCategory": "Organize & Edit",
    "requiresNetwork": false
  },
  {
    "id": "meta-tags",
    "name": "Meta Tags",
    "desc": "Generate and preview HTML meta tags to optimize website social sharing.",
    "href": "/developer-tools/meta-tags/",
    "category": "developer",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "meta tags",
      "seo"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "SEO Tools",
    "requiresNetwork": false
  },
  {
    "id": "metadata-viewer",
    "name": "Metadata Viewer",
    "desc": "Inspect file forensics, magic signatures, EXIF data, and privacy warnings entirely offline.",
    "href": "/security-tools/metadata-viewer/",
    "category": "security",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": null,
    "keywords": [
      "metadata",
      "exif",
      "forensics",
      "privacy",
      "file"
    ],
    "input": null,
    "output": null,
    "related": [
      "hash-generator"
    ],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "mic-camera-tester",
    "name": "Mic & Camera Tester",
    "desc": "Test your microphone and camera",
    "href": "/utilities/mic-camera-tester/",
    "category": "utilities",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": null,
    "keywords": [
      "mic test",
      "camera test",
      "webcam",
      "microphone",
      "online meeting"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "minesweeper",
    "name": "Minesweeper",
    "desc": "Classic Minesweeper puzzle. Clear the board without clicking on hidden mines. Multiple difficulties and mobile friendly controls.",
    "href": "/break-time-tools/minesweeper/",
    "category": "break-time",
    "icon": null,
    "color": "#8B5CF6",
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-07-11",
    "keywords": [
      "minesweeper",
      "mines",
      "logic game",
      "classic game",
      "brain break",
      "offline"
    ],
    "input": null,
    "output": null,
    "related": [
      "sudoku",
      "game-2048",
      "memory-match"
    ],
    "subCategory": "Puzzles",
    "requiresNetwork": false
  },
  {
    "id": "move-pages",
    "name": "Move PDF Pages",
    "desc": "Drag and drop to move pages around in your PDF document.",
    "href": "/pdf-tools/move-pages/",
    "category": "pdf",
    "icon": "↕️",
    "color": "#B91C1C",
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": null,
    "keywords": [
      "move pdf pages",
      "shift pages",
      "pdf order"
    ],
    "input": "pdf",
    "output": "pdf",
    "related": [],
    "subCategory": "Organize & Edit",
    "requiresNetwork": false
  },
  {
    "id": "mutual-fund-returns",
    "name": "Mutual Fund Returns",
    "desc": "Calculate absolute and annualized returns",
    "href": "/calculators/mutual-fund-returns/",
    "category": "calculators",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": null,
    "keywords": [
      "mutual fund",
      "returns",
      "absolute",
      "annualized",
      "yield"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Financial",
    "requiresNetwork": false
  },
  {
    "id": "nanoid-generator",
    "name": "Nanoid Generator",
    "desc": "Generate secure, URL-friendly unique string IDs using NanoID.",
    "href": "/developer-tools/nanoid-generator/",
    "category": "developer",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "nanoid generator",
      "developer"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Generators",
    "requiresNetwork": false
  },
  {
    "id": "notes",
    "name": "Notes",
    "desc": "Write and save markdown notes locally in your browser.",
    "href": "/productivity/notes/",
    "category": "productivity",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "notes",
      "productivity"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "nps-calculator",
    "name": "Nps Calculator",
    "desc": "Calculate National Pension Scheme (NPS) maturity amounts.",
    "href": "/calculators/nps-calculator/",
    "category": "calculators",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "nps calculator",
      "calculators"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "numeral-converter",
    "name": "Numeral & Encoding Converter",
    "desc": "Universal encoding converter. Paste hex, binary, Base64, URL-encoded, HTML entities, Unicode escapes, or plain text. Auto-detect format and convert to all others instantly. Supports UTF-8, UTF-16, UTF-32, Base64, URL encoding, HTML entities, JavaScript/Python/CSS escapes, Morse code, ROT13, JWT decode, and more. 100% local — nothing leaves your browser.",
    "href": "/calculators/numeral-converter/",
    "category": "calculators",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "numeral converter",
      "encoding converter",
      "decoding tool",
      "hex to text",
      "text to hex",
      "binary to text",
      "text to binary",
      "base64 decode",
      "base64 encode",
      "base64 url-safe",
      "url decode",
      "url encode",
      "percent encoding",
      "html entity decode",
      "html entity encode",
      "unicode escape",
      "javascript escape",
      "utf-8 converter",
      "utf-16 converter",
      "utf-32 converter",
      "ascii converter",
      "morse code converter",
      "rot13",
      "caesar cipher",
      "atbash cipher",
      "jwt decoder",
      "jwt token decode",
      "hex decoder",
      "binary decoder",
      "byte converter",
      "character encoding"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Math & Units",
    "requiresNetwork": false
  },
  {
    "id": "oauth-token-decoder",
    "name": "Oauth Token Decoder",
    "desc": "Inspect and decode OAuth 2.0 access and refresh token payloads.",
    "href": "/security-tools/oauth-token-decoder/",
    "category": "security",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "oauth token decoder",
      "security"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "odd-pages-extractor",
    "name": "Odd Pages Extractor",
    "desc": "Extract only the odd-numbered pages from a PDF document.",
    "href": "/pdf-tools/odd-pages-extractor/",
    "category": "pdf",
    "icon": "🔢",
    "color": "#B91C1C",
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": null,
    "keywords": [
      "extract odd pages",
      "odd pages only",
      "pdf odd pages"
    ],
    "input": "pdf",
    "output": "pdf",
    "related": [],
    "subCategory": "Organize & Edit",
    "requiresNetwork": false
  },
  {
    "id": "og-preview",
    "name": "Og Preview",
    "desc": "Preview Open Graph card layouts for social media platforms.",
    "href": "/developer-tools/og-preview/",
    "category": "developer",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "og preview",
      "seo"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "SEO Tools",
    "requiresNetwork": false
  },
  {
    "id": "organize-pdf",
    "name": "Organize PDF",
    "desc": "Sort, reorder, and organize pages in your PDF document visually.",
    "href": "/pdf-tools/organize-pdf/",
    "category": "pdf",
    "icon": "🗂️",
    "color": "#B91C1C",
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": null,
    "keywords": [
      "organize pdf",
      "rearrange pages",
      "sort pdf"
    ],
    "input": "pdf",
    "output": "pdf",
    "related": [],
    "subCategory": "Organize & Edit",
    "requiresNetwork": false
  },
  {
    "id": "page-numbering",
    "name": "Page Numbering",
    "desc": "Add page numbers to PDF",
    "href": "/pdf-tools/page-numbering/",
    "category": "pdf",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "pdf",
      "page",
      "number"
    ],
    "input": "pdf",
    "output": "pdf",
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "page-size-converter",
    "name": "Page Size Converter",
    "desc": "Convert PDF pages to a specific size",
    "href": "/pdf-tools/page-size-converter/",
    "category": "pdf",
    "icon": "Maximize",
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": null,
    "keywords": [
      "pdf",
      "resize",
      "scale",
      "layout"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Convert & Export",
    "requiresNetwork": false
  },
  {
    "id": "password-generator",
    "name": "Password Generator",
    "desc": "Strong, random passwords",
    "href": "/security-tools/password-generator/",
    "category": "security",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "password",
      "random",
      "strong",
      "generator"
    ],
    "input": null,
    "output": null,
    "related": [
      "hash-generator",
      "base64"
    ],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "pbkdf2-generator",
    "name": "Pbkdf2 Generator",
    "desc": "Derive cryptographic keys using PBKDF2 password hashing.",
    "href": "/security-tools/pbkdf2-generator/",
    "category": "security",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "pbkdf2 generator",
      "security"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "pdf-attachments",
    "name": "PDF Attachments",
    "desc": "Extract embedded files and attachments from PDFs",
    "href": "/pdf-tools/pdf-attachments/",
    "category": "pdf",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": null,
    "keywords": [
      "pdf",
      "attachments",
      "extract",
      "embedded",
      "files"
    ],
    "input": "pdf",
    "output": "any-file",
    "related": [],
    "subCategory": "Security & Metadata",
    "requiresNetwork": false
  },
  {
    "id": "pdf-bookmarks",
    "name": "PDF Bookmarks",
    "desc": "View and export PDF bookmarks (outline)",
    "href": "/pdf-tools/pdf-bookmarks/",
    "category": "pdf",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": null,
    "keywords": [
      "pdf",
      "bookmarks",
      "outline",
      "toc",
      "table of contents"
    ],
    "input": "pdf",
    "output": "json",
    "related": [],
    "subCategory": "Security & Metadata",
    "requiresNetwork": false
  },
  {
    "id": "pdf-compare",
    "name": "Compare PDFs",
    "desc": "Highlight textual and visual differences between two PDF files.",
    "href": "/pdf-tools/pdf-compare/",
    "category": "pdf",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": null,
    "keywords": [
      "compare",
      "pdf",
      "diff",
      "difference",
      "compare pdf",
      "pdf diff"
    ],
    "input": "pdf",
    "output": "none",
    "related": [
      "diff-checker",
      "merge-pdf",
      "pdf-editor"
    ],
    "subCategory": "View & Compare",
    "requiresNetwork": false
  },
  {
    "id": "pdf-editor",
    "name": "PDF Editor",
    "desc": "View and annotate PDF documents",
    "href": "/pdf-tools/pdf-editor/",
    "category": "pdf",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "pdf",
      "editor",
      "annotate",
      "draw",
      "text",
      "black out"
    ],
    "input": "pdf",
    "output": "pdf",
    "related": [],
    "subCategory": "View & Compare",
    "requiresNetwork": false
  },
  {
    "id": "pdf-preview",
    "name": "Preview PDF",
    "desc": "A native, fast, offline PDF viewer with search and zoom capabilities.",
    "href": "/pdf-tools/pdf-preview/",
    "category": "pdf",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": null,
    "keywords": [
      "preview",
      "pdf",
      "viewer",
      "read pdf",
      "pdf viewer"
    ],
    "input": "pdf",
    "output": "none",
    "related": [
      "pdf-editor",
      "pdf-bookmarks",
      "pdf-attachments"
    ],
    "subCategory": "View & Compare",
    "requiresNetwork": false
  },
  {
    "id": "pdf-to-image",
    "name": "PDF to Image",
    "desc": "Convert PDF pages to JPG or PNG images",
    "href": "/pdf-tools/pdf-to-image/",
    "category": "pdf",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "pdf",
      "image",
      "convert",
      "jpg",
      "png",
      "extract"
    ],
    "input": "pdf",
    "output": "image",
    "related": [],
    "subCategory": "Convert & Export",
    "requiresNetwork": false
  },
  {
    "id": "pdf-to-word",
    "name": "PDF to Word",
    "desc": "Convert PDF text to editable Word",
    "href": "/pdf-tools/pdf-to-word/",
    "category": "pdf",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "pdf",
      "word",
      "docx",
      "convert"
    ],
    "input": "pdf",
    "output": "text",
    "related": [],
    "subCategory": "Convert & Export",
    "requiresNetwork": false
  },
  {
    "id": "pem-viewer",
    "name": "Pem Viewer",
    "desc": "Inspect and parse PEM certificate and private key files.",
    "href": "/security-tools/pem-viewer/",
    "category": "security",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "pem viewer",
      "security"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "percentage-calculator",
    "name": "Percentage Calculator",
    "desc": "Calculate percentages, percentage increase/decrease, ratios, and reverse original values with precision math",
    "href": "/calculators/percentage-calculator/",
    "category": "calculators",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "percent",
      "percentage",
      "percentage calculator",
      "percent change",
      "percentage increase",
      "percentage decrease",
      "reverse percentage",
      "ratio"
    ],
    "input": null,
    "output": null,
    "related": [
      "discount-calculator",
      "gst-calculator",
      "cagr-calculator",
      "calculator"
    ],
    "subCategory": "Math & Units",
    "requiresNetwork": false
  },
  {
    "id": "phone-mockup-generator",
    "name": "Phone Mockup Generator",
    "desc": "Wrap screenshots in realistic device frames",
    "href": "/image-tools/phone-mockup-generator/",
    "category": "image",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": null,
    "keywords": [
      "mockup",
      "phone",
      "iphone",
      "android",
      "screenshot",
      "presentation"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "pomodoro-timer",
    "name": "Pomodoro Timer",
    "desc": "Boost your focus and productivity using the Pomodoro technique.",
    "href": "/productivity/pomodoro-timer/",
    "category": "productivity",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "pomodoro timer",
      "productivity"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "ppf-calculator",
    "name": "PPF Calculator",
    "desc": "Public Provident Fund maturity & interest",
    "href": "/calculators/ppf-calculator/",
    "category": "calculators",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": null,
    "keywords": [
      "ppf",
      "savings",
      "tax saving",
      "interest",
      "maturity"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Financial",
    "requiresNetwork": false
  },
  {
    "id": "private-key-checker",
    "name": "Private Key Checker",
    "desc": "Validate private key structures and format compatibility.",
    "href": "/security-tools/private-key-checker/",
    "category": "security",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "private key checker",
      "security"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "public-key-inspector",
    "name": "Public Key Inspector",
    "desc": "Inspect and display properties of public keys.",
    "href": "/security-tools/public-key-inspector/",
    "category": "security",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "public key inspector",
      "security"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "qa-workbench",
    "name": "QA Workbench",
    "desc": "Unified testing suite for developers: API requests, Regex, Text Diff, JSON formatting, and Mock Data.",
    "href": "/developer-tools/qa-workbench/",
    "category": "developer",
    "icon": null,
    "color": null,
    "featured": true,
    "popular": false,
    "status": "beta",
    "lastAdded": "2026-07-25",
    "keywords": [
      "qa",
      "workbench",
      "testing",
      "regex",
      "diff",
      "json",
      "mock data",
      "api tester"
    ],
    "input": "text",
    "output": "text",
    "related": [
      "regex-tester",
      "json-formatter",
      "text-diff",
      "fake-data-generator"
    ],
    "subCategory": "Developer",
    "requiresNetwork": false
  },
  {
    "id": "qrcode",
    "name": "QR Code Generator",
    "desc": "Make QR codes for URLs, text, Wi-Fi",
    "href": "/utilities/qrcode/",
    "category": "utilities",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "qr",
      "qrcode",
      "barcode"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "rd-calculator",
    "name": "Recurring Deposit (RD) Calculator",
    "desc": "Calculate RD maturity amount, quarterly compound interest, senior citizen rate boost, and Section 194A TDS deductions",
    "href": "/calculators/rd-calculator/",
    "category": "calculators",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "rd calculator",
      "recurring deposit calculator",
      "rd interest calculator",
      "rd maturity calculator",
      "post office rd",
      "sbi rd calculator",
      "quarterly compounding rd",
      "senior citizen rd",
      "rd tds calculation"
    ],
    "input": null,
    "output": null,
    "related": [
      "fd-calculator",
      "sip-calculator",
      "ppf-calculator",
      "compound-interest",
      "interest-calculator"
    ],
    "subCategory": "Finance & Investment",
    "requiresNetwork": false
  },
  {
    "id": "reaction-time",
    "name": "Reaction Time Test",
    "desc": "Test your reflexes and measure your reaction speed in milliseconds.",
    "href": "/break-time-tools/reaction-time/",
    "category": "break-time",
    "icon": null,
    "color": "#8B5CF6",
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-07-10",
    "keywords": [
      "reaction time",
      "reflexes",
      "speed",
      "test",
      "brain game",
      "cognitive"
    ],
    "input": null,
    "output": null,
    "related": [
      "color-match",
      "tic-tac-toe"
    ],
    "subCategory": "Skill Tests",
    "requiresNetwork": false
  },
  {
    "id": "regex-tester",
    "name": "Regex Tester",
    "desc": "Test regular expressions live",
    "href": "/developer-tools/regex/",
    "category": "developer",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "regex",
      "regexp",
      "match",
      "pattern"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Other",
    "requiresNetwork": false
  },
  {
    "id": "remove-metadata",
    "name": "Remove PDF Metadata",
    "desc": "Clear all metadata and properties from a PDF document",
    "href": "/pdf-tools/remove-metadata/",
    "category": "pdf",
    "icon": "Eraser",
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": null,
    "keywords": [
      "pdf",
      "metadata",
      "properties",
      "remove",
      "clear",
      "privacy"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Security & Metadata",
    "requiresNetwork": false
  },
  {
    "id": "remove-pages",
    "name": "Remove PDF Pages",
    "desc": "Easily delete and remove unwanted pages from any PDF document offline.",
    "href": "/pdf-tools/remove-pages/",
    "category": "pdf",
    "icon": "🗑️",
    "color": "#B91C1C",
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": null,
    "keywords": [
      "remove pdf pages",
      "delete pdf pages",
      "extract"
    ],
    "input": "pdf",
    "output": "pdf",
    "related": [],
    "subCategory": "Organize & Edit",
    "requiresNetwork": false
  },
  {
    "id": "reorder-pages",
    "name": "Reorder PDF Pages",
    "desc": "Easily reorder the pages of your PDF document.",
    "href": "/pdf-tools/reorder-pages/",
    "category": "pdf",
    "icon": "🔃",
    "color": "#B91C1C",
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": null,
    "keywords": [
      "reorder pdf pages",
      "change page order",
      "move pages"
    ],
    "input": "pdf",
    "output": "pdf",
    "related": [],
    "subCategory": "Organize & Edit",
    "requiresNetwork": false
  },
  {
    "id": "retirement-calculator",
    "name": "Retirement Planner",
    "desc": "Corpus needed for your retirement",
    "href": "/calculators/retirement-calculator/",
    "category": "calculators",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": null,
    "keywords": [
      "retirement",
      "planning",
      "pension",
      "corpus",
      "savings"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Financial",
    "requiresNetwork": false
  },
  {
    "id": "reverse-pages",
    "name": "Reverse PDF Pages",
    "desc": "Reverse the order of pages in a PDF document instantly.",
    "href": "/pdf-tools/reverse-pages/",
    "category": "pdf",
    "icon": "🔄",
    "color": "#B91C1C",
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": null,
    "keywords": [
      "reverse pdf",
      "reverse page order",
      "flip pages"
    ],
    "input": "pdf",
    "output": "pdf",
    "related": [],
    "subCategory": "Organize & Edit",
    "requiresNetwork": false
  },
  {
    "id": "robots-txt",
    "name": "Robots Txt",
    "desc": "Generate and validate robots.txt configurations for SEO crawlers.",
    "href": "/developer-tools/robots-txt/",
    "category": "developer",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "robots txt",
      "seo"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "SEO Tools",
    "requiresNetwork": false
  },
  {
    "id": "rotate-pdf",
    "name": "Rotate PDF",
    "desc": "Rotate one or all pages",
    "href": "/pdf-tools/rotate-pdf/",
    "category": "pdf",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "pdf",
      "rotate",
      "flip",
      "orientation"
    ],
    "input": "pdf",
    "output": "pdf",
    "related": [],
    "subCategory": "Organize & Edit",
    "requiresNetwork": false
  },
  {
    "id": "rotate-selected-pages",
    "name": "Rotate Selected Pages",
    "desc": "Rotate specific pages in your PDF without rotating the whole document.",
    "href": "/pdf-tools/rotate-selected-pages/",
    "category": "pdf",
    "icon": "⤵️",
    "color": "#B91C1C",
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": null,
    "keywords": [
      "rotate specific pages",
      "rotate pdf pages",
      "pdf page rotation"
    ],
    "input": "pdf",
    "output": "pdf",
    "related": [],
    "subCategory": "Organize & Edit",
    "requiresNetwork": false
  },
  {
    "id": "rsa-encrypt-decrypt",
    "name": "Rsa Encrypt Decrypt",
    "desc": "Encrypt or decrypt payloads using secure RSA key pairs.",
    "href": "/security-tools/rsa-encrypt-decrypt/",
    "category": "security",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "rsa encrypt decrypt",
      "security"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "rsa-key-generator",
    "name": "Rsa Key Generator",
    "desc": "Generate public and private RSA key pairs locally for authentication.",
    "href": "/security-tools/rsa-key-generator/",
    "category": "security",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "rsa key generator",
      "security"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "rsa-sign-verify",
    "name": "Rsa Sign Verify",
    "desc": "Sign messages or verify signatures using RSA keys.",
    "href": "/security-tools/rsa-sign-verify/",
    "category": "security",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "rsa sign verify",
      "security"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "safe-to-spend",
    "name": "Safe-to-Spend",
    "desc": "Daily budget planner",
    "href": "/calculators/safe-to-spend/",
    "category": "calculators",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "budget",
      "spending",
      "daily"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Financial",
    "requiresNetwork": false
  },
  {
    "id": "salary-calculator",
    "name": "Salary & Take-Home Pay Calculator",
    "desc": "Calculate Indian take-home monthly salary, gross vs net CTC breakdown, EPF, professional tax, and income tax under Old vs New Regime",
    "href": "/calculators/salary-calculator/",
    "category": "calculators",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "salary calculator",
      "take home salary calculator",
      "in hand salary calculator",
      "ctc to in hand calculator",
      "ctc calculator",
      "salary breakdown india",
      "income tax salary calculator",
      "epf deduction calculator",
      "new tax regime salary",
      "old tax regime salary",
      "gross to net salary"
    ],
    "input": null,
    "output": null,
    "related": [
      "income-tax",
      "hra-calculator",
      "gratuity-calculator",
      "tds-calculator",
      "financial-freedom-calculator"
    ],
    "subCategory": "Finance & Payroll",
    "requiresNetwork": false
  },
  {
    "id": "saml-decoder",
    "name": "Saml Decoder",
    "desc": "Decode and format SAML assertion payloads for identity analysis.",
    "href": "/security-tools/saml-decoder/",
    "category": "security",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "saml decoder",
      "security"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "seo-title",
    "name": "Seo Title",
    "desc": "Optimize SEO title tags to maximize search engine click-through rates.",
    "href": "/developer-tools/seo-title/",
    "category": "developer",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "seo title",
      "seo"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "SEO Tools",
    "requiresNetwork": false
  },
  {
    "id": "seo-tools",
    "name": "Seo Tools",
    "desc": "Inspect and optimize website SEO meta tags and preview search snippets.",
    "href": "/developer-tools/seo-tools/",
    "category": "developer",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "seo tools",
      "developer"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "SEO & Marketing",
    "requiresNetwork": false
  },
  {
    "id": "sip-calculator",
    "name": "SIP Calculator",
    "desc": "Project mutual fund and equity SIP returns with step-up compounding, lumpsum deposits, tax deductions, and inflation adjustments",
    "href": "/calculators/sip-calculator/",
    "category": "calculators",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "sip",
      "sip calculator",
      "step up sip",
      "mutual fund calculator",
      "investment returns",
      "wealth planner",
      "systematic investment plan",
      "inflation adjusted sip",
      "compound growth"
    ],
    "input": null,
    "output": null,
    "related": [
      "compound-interest",
      "cagr-calculator",
      "swp-calculator",
      "retirement-calculator",
      "emi-calculator"
    ],
    "subCategory": "Finance & Investment",
    "requiresNetwork": false
  },
  {
    "id": "sitemap-generator",
    "name": "Sitemap Generator",
    "desc": "Generate XML sitemaps to index website pages.",
    "href": "/developer-tools/sitemap-generator/",
    "category": "developer",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "sitemap generator",
      "seo"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "SEO Tools",
    "requiresNetwork": false
  },
  {
    "id": "slug-generator",
    "name": "Slug Generator",
    "desc": "Convert text into URL-friendly slug strings.",
    "href": "/developer-tools/slug-generator/",
    "category": "developer",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "slug generator",
      "seo"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "SEO Tools",
    "requiresNetwork": false
  },
  {
    "id": "smart-converter",
    "name": "Smart Unit Converter",
    "desc": "Natural-language unit conversion",
    "href": "/calculators/smart-converter/",
    "category": "calculators",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "convert",
      "smart",
      "natural language"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Math & Units",
    "requiresNetwork": false
  },
  {
    "id": "snake-game",
    "name": "Snake Game",
    "desc": "Play the classic retro Snake game. Eat food, grow longer, and set new high scores entirely in your browser.",
    "href": "/break-time-tools/snake-game/",
    "category": "break-time",
    "icon": null,
    "color": "#8B5CF6",
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-07-11",
    "keywords": [
      "snake",
      "arcade",
      "retro",
      "classic game",
      "brain break",
      "fun",
      "offline"
    ],
    "input": null,
    "output": null,
    "related": [
      "game-2048",
      "reaction-time",
      "tic-tac-toe"
    ],
    "subCategory": "Games",
    "requiresNetwork": false
  },
  {
    "id": "split-copy",
    "name": "Split & Copy",
    "desc": "Break long text into chunks",
    "href": "/utilities/split-copy/",
    "category": "utilities",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "split",
      "copy",
      "text",
      "chunks"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "split-pdf",
    "name": "Split PDF",
    "desc": "Extract pages from a PDF",
    "href": "/pdf-tools/split-pdf/",
    "category": "pdf",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": null,
    "keywords": [
      "pdf",
      "split",
      "extract",
      "pages"
    ],
    "input": "pdf",
    "output": "pdf",
    "related": [],
    "subCategory": "Organize & Edit",
    "requiresNetwork": false
  },
  {
    "id": "sql-formatter",
    "name": "Sql Formatter",
    "desc": "Beautify and format complex SQL queries to improve readability.",
    "href": "/developer-tools/sql-formatter/",
    "category": "developer",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "sql formatter",
      "developer"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Formatters & Minifiers",
    "requiresNetwork": false
  },
  {
    "id": "stock-average-calculator",
    "name": "Stock Average",
    "desc": "Weighted average buy price for stocks",
    "href": "/calculators/stock-average-calculator/",
    "category": "calculators",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": null,
    "keywords": [
      "stock",
      "average",
      "buy price",
      "trading",
      "investing"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Financial",
    "requiresNetwork": false
  },
  {
    "id": "stopwatch",
    "name": "Stopwatch",
    "desc": "Track elapsed time with lap support for productivity logging.",
    "href": "/productivity/stopwatch/",
    "category": "productivity",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "stopwatch",
      "productivity"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "sudoku",
    "name": "Sudoku",
    "desc": "Classic 9x9 Sudoku logical number placement puzzle with multiple difficulty modes, hints, and local best times.",
    "href": "/break-time-tools/sudoku/",
    "category": "break-time",
    "icon": null,
    "color": "#8B5CF6",
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-07-11",
    "keywords": [
      "sudoku",
      "number puzzle",
      "logic game",
      "brain training",
      "puzzle",
      "offline"
    ],
    "input": null,
    "output": null,
    "related": [
      "game-2048",
      "memory-match",
      "word-guess"
    ],
    "subCategory": "Puzzles",
    "requiresNetwork": false
  },
  {
    "id": "super-resolution",
    "name": "AI Image Upscaler",
    "desc": "Upscale and enhance images 2x or 4x locally using Real-ESRGAN AI",
    "href": "/image-tools/super-resolution/",
    "category": "image",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": true,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "image",
      "upscale",
      "super resolution",
      "realesrgan",
      "enhance",
      "clarity"
    ],
    "input": "image",
    "output": "image",
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "svg-converter",
    "name": "SVG to PNG",
    "desc": "Rasterize vector SVG files to transparent PNGs",
    "href": "/image-tools/svg-converter/",
    "category": "image",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "svg",
      "png",
      "convert",
      "vector",
      "raster",
      "transparent"
    ],
    "input": "image",
    "output": "image",
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "swift-mt-mx",
    "name": "Swift Mt Mx",
    "desc": "Parse and inspect SWIFT MT and MX banking message structures.",
    "href": "/developer-tools/swift-mt-mx/",
    "category": "developer",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "swift mt mx",
      "banking"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Banking Tools",
    "requiresNetwork": false
  },
  {
    "id": "swp-calculator",
    "name": "SWP Calculator",
    "desc": "Systematic Withdrawal Plan planning",
    "href": "/calculators/swp-calculator/",
    "category": "calculators",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": null,
    "keywords": [
      "swp",
      "withdrawal",
      "pension",
      "mutual fund",
      "income"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Financial",
    "requiresNetwork": false
  },
  {
    "id": "task-reminder",
    "name": "Task Reminder",
    "desc": "Lightweight private to-do list",
    "href": "/utilities/task-reminder/",
    "category": "utilities",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "task",
      "todo",
      "reminder",
      "list"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "tds-calculator",
    "name": "Tds Calculator",
    "desc": "Calculate Tax Deducted at Source (TDS) percentages.",
    "href": "/calculators/tds-calculator/",
    "category": "calculators",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "tds calculator",
      "calculators"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "text-case-converter",
    "name": "Text Case Converter",
    "desc": "Convert text between UPPERCASE, lowercase, and sentence case styles.",
    "href": "/productivity/text-case-converter/",
    "category": "productivity",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "text case converter",
      "productivity"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "text-sorter-deduper",
    "name": "Text Sorter & Deduplicator",
    "desc": "Sort and remove duplicates from text",
    "href": "/productivity/text-sorter-deduper/",
    "category": "productivity",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": null,
    "keywords": [
      "sort",
      "deduplicate",
      "text",
      "lines",
      "alphabetical"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "text-utility",
    "name": "Text Utility",
    "desc": "Clean, case convert, count words",
    "href": "/utilities/text-utility/",
    "category": "utilities",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "text",
      "case",
      "word count",
      "clean"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "tic-tac-toe",
    "name": "Tic-Tac-Toe",
    "desc": "Classic 2-player Tic-Tac-Toe right in your browser. No downloads, no sign-in.",
    "href": "/break-time-tools/tic-tac-toe/",
    "category": "break-time",
    "icon": null,
    "color": "#8B5CF6",
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-07-09",
    "keywords": [
      "tic tac toe",
      "game",
      "fun",
      "brain break",
      "two player",
      "noughts and crosses"
    ],
    "input": null,
    "output": null,
    "related": [
      "memory-match",
      "game-2048"
    ],
    "subCategory": "Games",
    "requiresNetwork": false
  },
  {
    "id": "tiff-converter",
    "name": "TIFF Converter",
    "desc": "Convert to and from the professional TIFF image format",
    "href": "/image-tools/tiff-converter/",
    "category": "image",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "tiff",
      "tif",
      "convert",
      "photo",
      "professional",
      "lossless"
    ],
    "input": "image",
    "output": "image",
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "time-calculator",
    "name": "Time Calculator",
    "desc": "Calculate time intervals, sum durations, or add/subtract time with midnight rollover precision",
    "href": "/calculators/time-calculator/",
    "category": "calculators",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "time",
      "duration",
      "hours",
      "minutes",
      "time difference",
      "add time",
      "timesheet",
      "overnight shift"
    ],
    "input": null,
    "output": null,
    "related": [
      "date-calculator",
      "age-calculator",
      "work-hours",
      "stopwatch"
    ],
    "subCategory": "Date & Time",
    "requiresNetwork": false
  },
  {
    "id": "timezone-converter",
    "name": "Time Zone Converter",
    "desc": "Compare and convert time between multiple global time zones. Real-time offsets and DST support.",
    "href": "/productivity/timezone-converter/",
    "category": "productivity",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": null,
    "keywords": [
      "timezone",
      "converter",
      "world clock",
      "time",
      "iana",
      "dst",
      "meeting planner",
      "utc converter",
      "local time"
    ],
    "input": null,
    "output": null,
    "related": [
      "world-clock",
      "utc-ist-converter",
      "date-calculator",
      "time-calculator"
    ],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "tlv-parser",
    "name": "Tlv Parser",
    "desc": "Parse and visualize EMV TLV hex streams into clear tree structures.",
    "href": "/security-tools/tlv-parser/",
    "category": "security",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "tlv parser",
      "security"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "track-2-parser",
    "name": "Track 2 Parser",
    "desc": "Decode magnetic stripe Track 2 data for payment card testing.",
    "href": "/developer-tools/track-2-parser/",
    "category": "developer",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "track 2 parser",
      "banking"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Banking Tools",
    "requiresNetwork": false
  },
  {
    "id": "typing-speed-test",
    "name": "Typing Speed Test",
    "desc": "Test and improve your typing WPM",
    "href": "/productivity/typing-speed-test/",
    "category": "productivity",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": null,
    "keywords": [
      "typing test",
      "wpm",
      "accuracy",
      "keyboard",
      "typing speed"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "unit-converter",
    "name": "Unit Converter",
    "desc": "Length, weight, volume, and more",
    "href": "/calculators/unit-converter/",
    "category": "calculators",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "unit",
      "convert",
      "length",
      "weight",
      "volume",
      "metric"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Math & Units",
    "requiresNetwork": false
  },
  {
    "id": "unix-timestamp",
    "name": "Unix Timestamp Converter",
    "desc": "Convert between Unix epoch timestamps (seconds, ms, μs, ns) and human-readable dates with timezones, batch conversion, and code snippets.",
    "href": "/developer-tools/unix-timestamp/",
    "category": "developer",
    "icon": "Clock",
    "color": null,
    "featured": true,
    "popular": true,
    "status": "stable",
    "lastAdded": "2026-08-27",
    "keywords": [
      "unix timestamp",
      "epoch converter",
      "timestamp to date",
      "date to epoch",
      "epoch math",
      "batch timestamp converter",
      "iso 8601",
      "utc converter"
    ],
    "input": "text",
    "output": "json",
    "related": [
      "utc-ist-converter",
      "date-calculator",
      "time-calculator",
      "crontab-editor"
    ],
    "subCategory": "Converters",
    "requiresNetwork": false
  },
  {
    "id": "url-cleaner",
    "name": "URL Cleaner",
    "desc": "Strip tracking parameters",
    "href": "/utilities/url-cleaner/",
    "category": "utilities",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "url",
      "clean",
      "tracking",
      "utm"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "url-encoder",
    "name": "URL Encoder",
    "desc": "Percent-encode and decode URLs",
    "href": "/developer-tools/url-encoder/",
    "category": "developer",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "url",
      "encode",
      "decode",
      "percent"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Converters",
    "requiresNetwork": false
  },
  {
    "id": "utc-ist-converter",
    "name": "UTC ↔ IST",
    "desc": "Convert between UTC and IST",
    "href": "/calculators/utc-ist-converter/",
    "category": "calculators",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "utc",
      "ist",
      "timezone",
      "india"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Date & Time",
    "requiresNetwork": false
  },
  {
    "id": "uuid-generator",
    "name": "Uuid Generator",
    "desc": "Generate secure v4 UUIDs for database and entity keys.",
    "href": "/developer-tools/uuid-generator/",
    "category": "developer",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "uuid generator",
      "developer"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Generators",
    "requiresNetwork": false
  },
  {
    "id": "validate",
    "name": "File Validator",
    "desc": "Validate file size and type",
    "href": "/utilities/validate/",
    "category": "utilities",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "validate",
      "file",
      "size",
      "type"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "video-metadata-viewer",
    "name": "Video Metadata Viewer",
    "desc": "Extract and inspect resolution, codec, and duration metadata from video files.",
    "href": "/media-tools/video-metadata-viewer/",
    "category": "media",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "video metadata viewer",
      "media"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "video-trim",
    "name": "Video Trim",
    "desc": "Trim and cut MP4 video clips directly in your browser.",
    "href": "/media-tools/video-trim/",
    "category": "media",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "video trim",
      "media"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "watermark-pdf",
    "name": "Watermark PDF",
    "desc": "Add text or image watermark",
    "href": "/pdf-tools/watermark-pdf/",
    "category": "pdf",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "pdf",
      "watermark",
      "stamp"
    ],
    "input": "pdf",
    "output": "pdf",
    "related": [],
    "subCategory": "Security & Metadata",
    "requiresNetwork": false
  },
  {
    "id": "webp-converter",
    "name": "WebP Converter",
    "desc": "Convert any image to the highly optimized WebP format",
    "href": "/image-tools/webp-converter/",
    "category": "image",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "image",
      "convert",
      "webp",
      "optimization",
      "compress"
    ],
    "input": "image",
    "output": "image",
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "wifi-qr-code",
    "name": "WiFi QR Code Generator",
    "desc": "Generate QR code to connect to WiFi",
    "href": "/productivity/wifi-qr-code/",
    "category": "productivity",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": null,
    "keywords": [
      "wifi",
      "qr code",
      "generator",
      "wpa",
      "wep",
      "network"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "word-counter",
    "name": "Word Counter",
    "desc": "Count characters, words, sentences, and reading times for any text.",
    "href": "/productivity/word-counter/",
    "category": "productivity",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "word counter",
      "productivity"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "word-guess",
    "name": "Word Guess",
    "desc": "A word guessing puzzle game. Find the secret 5-letter word in 6 tries using visual feedback.",
    "href": "/break-time-tools/word-guess/",
    "category": "break-time",
    "icon": null,
    "color": "#8B5CF6",
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-07-11",
    "keywords": [
      "word guess",
      "wordle",
      "word game",
      "puzzle",
      "vocabulary",
      "brain training",
      "spelling",
      "offline"
    ],
    "input": null,
    "output": null,
    "related": [
      "memory-match",
      "color-match",
      "tic-tac-toe"
    ],
    "subCategory": "Word Games",
    "requiresNetwork": false
  },
  {
    "id": "word-to-pdf",
    "name": "Word To Pdf",
    "desc": "Convert Word documents (DOCX) into standard PDF files locally.",
    "href": "/pdf-tools/word-to-pdf/",
    "category": "pdf",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "word to pdf",
      "pdf"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Convert & Export",
    "requiresNetwork": false
  },
  {
    "id": "work-hours",
    "name": "Work Hours",
    "desc": "Timesheet and overtime tracker",
    "href": "/calculators/work-hours/",
    "category": "calculators",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "work",
      "hours",
      "timesheet",
      "overtime"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Date & Time",
    "requiresNetwork": false
  },
  {
    "id": "world-clock",
    "name": "World Clock",
    "desc": "Track time across multiple cities with business hour indicators. Ideal for global teams.",
    "href": "/calculators/world-clock/",
    "category": "calculators",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "stable",
    "lastAdded": null,
    "keywords": [
      "time",
      "timezone",
      "clock",
      "utc",
      "global time",
      "time zone converter",
      "meeting planner"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Date & Time",
    "requiresNetwork": false
  },
  {
    "id": "x509-viewer",
    "name": "X509 Viewer",
    "desc": "Inspect and validate X.509 security certificates and expiry details.",
    "href": "/security-tools/x509-viewer/",
    "category": "security",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "x509 viewer",
      "security"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": null,
    "requiresNetwork": false
  },
  {
    "id": "xml-formatter",
    "name": "Xml Formatter",
    "desc": "Format and prettify nested XML documents to inspect data tags.",
    "href": "/developer-tools/xml-formatter/",
    "category": "developer",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "xml formatter",
      "developer"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Formatters & Minifiers",
    "requiresNetwork": false
  },
  {
    "id": "yaml-json-converter",
    "name": "Yaml Json Converter",
    "desc": "Convert between YAML formatting and JSON objects.",
    "href": "/developer-tools/yaml-json-converter/",
    "category": "developer",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "yaml json converter",
      "developer"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Converters",
    "requiresNetwork": false
  },
  {
    "id": "yaml-validator",
    "name": "Yaml Validator",
    "desc": "Verify and validate YAML syntax correctness.",
    "href": "/developer-tools/yaml-validator/",
    "category": "developer",
    "icon": null,
    "color": null,
    "featured": false,
    "popular": false,
    "status": "new",
    "lastAdded": "2026-09-28",
    "keywords": [
      "yaml validator",
      "developer"
    ],
    "input": null,
    "output": null,
    "related": [],
    "subCategory": "Validators & Checkers",
    "requiresNetwork": false
  }
];
